import { gracefulDegradationMessage } from '../../shared/errorMessages';
import { AUTH_CHECK_IDENTIFIER_PATH } from '../../shared/endpoints/auth';
import {
    ValidateUserIdentifierRequestBody,
    ValidateUserIdentifierResponseBody,
} from '../../shared/requests';
import { makeRequest } from '../fetch';

export async function checkUserIdentifierUniqueness(
    userIdentifier: string,
    queryParams: string = '',
    awsToken: string = ''
) {
    try {
        const headers: Record<string, string> = {};

        if (awsToken) {
            headers['x-aws-waf-token'] = awsToken;
        }

        return await makeRequest<
            ValidateUserIdentifierRequestBody,
            ValidateUserIdentifierResponseBody
        >(`${AUTH_CHECK_IDENTIFIER_PATH}${queryParams}`, {
            method: 'post',
            body: { userIdentifier },
            headers,
        });
    } catch (error) {
        throw new Error(gracefulDegradationMessage);
    }
}
